<template>
  <b-modal
    ref="addWidgetModal"
    hide-footer
    centered
    :title="modalTitle"
    size="lg"
    @shown="shown = true"
    @hidden="shown = false"
    no-close-on-backdrop
    no-close-on-esc
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
        >
        <b-form-input
          type="text"
          v-model.trim="title"
        />
      </b-form-group>
      <b-form-group
        label="Classes:"
      >
        <b-form-input
          type="text"
          v-model.trim="classes"
        />
      </b-form-group>
      <div >
        <b-form-group label="Layout:">
          <b-form-select v-model="layout" :options="layouts"></b-form-select>
        </b-form-group>
      </div>
      <div v-if="widgetType === 'card-list'">
        <b-form-group label="Data Source:">
          <b-form-select
            v-model.trim="$v.dataSource.$model"
            :class="{ 'is-invalid': $v.dataSource.$error }"
            :disabled="inProgress"
          >
            <optgroup
              v-for="modelType in dataSourceList"
              :key="modelType.text"
              :label="modelType.text"
            >
              <option
                v-for="model in modelType.value"
                :key="model.text"
                :value="model.value"
              >
                {{ model.text }}
              </option>
            </optgroup>
          </b-form-select>
          <b-form-invalid-feedback
            v-if="!$v.dataSource.required"
          >
            Data Source is required
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <b-form-group
        label="List card template:"
      >
        <div class="templateEditor">
          <codemirror
            v-if="shown"
            :value="code"
            :options="cmOptions"
            @input="onCmCodeChange"
            @keydown.ctrl.83.native.prevent="save"
            />
        </div>
      </b-form-group>
      <b-form-group  v-if="widgetType === 'card-list'"
        label="Detail Template:"
      >
        <div class="templateEditor">
          <codemirror
            v-if="shown"
            :value="detailCode"
            :options="cmOptions"
            @input="onCmDetailCodeChange"
            @keydown.ctrl.83.native.prevent="save"
            />
        </div>
      </b-form-group>


      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required, numeric } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['widgetsComputed'],
  data () {
    return {
      gsData: {},
      shown: false,
      title: null,
      classes: null,
      layout: 'b-card',
      layouts: [
        { text: 'B-Card', value: 'b-card' },
        { text: 'Standard', value: null }
      ],
      code: '',
      detailCode:'',
      cmOptions: {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter'
        ],
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        hintOptions: {
          completeSingle: true
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        },
        mode: 'text/x-vue'
      },
      widgetType: null,
      dataSource: null,
      inProgress: false
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'dataGrid_options'
    ]),
    modalTitle () {
      const title = 'Create New widget'

      switch (this.widgetType) {
        case 'card-list': return 'Create Card List'
      }

      return title
    },
    dataSourceList () {
      const list = []
      const computed = []
      const dataGrids = []

      for (let key in this.widgetsComputed) {
        computed.push({ text: key, value: key })
      }

      for (let key in this.dataGrid_options) {
        const options = this.dataGrid_options[key]
        if (!options) {
          continue
        }
        let model

        model = this.widgetType === 'card-list' ? options.source : `$getDataGridVals($getGrid('${options.source}'))`

        dataGrids.push({ text: options.title, value: model })
      }

      list.push({ text: 'Computed Properties', value: computed })
      list.push({ text: 'Data Grids', value: dataGrids })

      return list
    }
  },
  methods: {
    onCmCodeChange (code) {
      this.code = code
    },
    onCmDetailCodeChange (code) {
      this.detailCode = code
    },
    save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      let data = {
        title: this.title,
        gsOptions: this.gsData,
        classes: this.classes,
        layout: this.layout,
        template: this.code,
        detailTemplate: this.detailCode,
        tab: this.currentTab,
        dataSource: this.dataSource,
        type: this.widgetType
      }
      if (this.currentSubTab) data.subtab = this.currentSubTab,

      this.$store.commit('addProcess', {
        process: 'addWidget',
        message: 'Creating'
      })

      db.widgets.create(data, (key) => {
        if (this.$refs.addWidgetModal) this.$refs.addWidgetModal.hide()
        this.code = ''
        this.detailCode = ''
        this.title = null
        this.dataSource = null
        this.gsData = {};
        this.$store.commit('addedWidgetKey', key);
        this.$store.commit('deleteProcess', 'addWidget')
        this.$store.commit('editWidget', {
          key,
          insert: true
        })

        this.inProgress = false
        this.$nextTick(() => {
          this.$v.$reset()
        })
      })
    }
  },
  created () {
    eventBus.$on('showAddWidgetModal', ({ data: widgetType, gsOptions }) => {
      this.gsData = gsOptions;
      if (this.$refs.addWidgetModal) this.$refs.addWidgetModal.show();
      this.widgetType = (widgetType) ? widgetType : null;

      this.layout = 'b-card';

      switch (this.widgetType) {
        case 'card-list':
          this.layout = null
      }
    })
  },
  mounted () {
    if (this.$refs.addWidgetModal) {
      $(this.$refs.addWidgetModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addWidgetModal) {
      $(this.$refs.addWidgetModal['$el']).remove()
    }
  },
  validations: {
    dataSource: {
      required () {
        if (this.widgetType === 'card-list' && !this.dataSource) return false
        return true
      }
    }
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.templateEditor {
  height: 40vh;
  border: 1px solid $borderColor1;
}
.vue-codemirror {
  height: 100%;
}
.CodeMirror {
  height: 100%;
}
.gridstackSize {
  @include cf;
  &__item {
    @include span(6)
    &:first-child {
      padding-right: 10px;
    }
    &:last-child {
      padding-left: 20px;
    }
    @include breakpoint(max-width $screenSm) {
      @include span(12)
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
}
</style>
